import { defineComponent as _defineComponent } from 'vue'
import HtmlImage from '@/components/util/HtmlImage.vue';
import NewModalDialog from '@/components/dialogs/NewModalDialog.vue';
import {
  PropType, computed, onMounted, ref,
} from 'vue';
import i18n from '@/plugins/i18n';
import MarketingCampaign, { MarketingCampaignStatus } from '@/grpc-api/model/marketing-campaign';
import nameWithCopyText from '@/util/copy-name';
import HtmlTemplate from '@/grpc-api/model/html-template';
import { performSaveAction } from '@/services/vue-utils';
import store from '@/store/store';
import router from '@/router';
import EmailPreviewFrame from './EmailPreviewFrame.vue';
import NewsletterFunnelChart from './NewsletterFunnelChart.vue';
import NewsletterGaugeChart from './NewsletterGaugeChart.vue';
import { colorForCampaignStatus } from './newsletter';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsletterCampaignDetailsDialog',
  props: {
  campaign: { type: Object as PropType<MarketingCampaign>, required: true },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;






const saveAsTemplate = async () => {
  if (!props.campaign.templateDesign) return;

  const name = nameWithCopyText(props.campaign.templateName ?? 'new', i18n.t('label.copy_of') as string);
  const htmlTemplate = new HtmlTemplate({
    name,
    design: props.campaign.templateDesign,
    html: props.campaign.templateHtml ?? undefined,
    preview: props.campaign.templatePreview ?? undefined,
  });

  const ok = await performSaveAction(
    undefined,
    async () => store.dispatch('marketingCampaignManagerCreateHtmlTemplate', { htmlTemplate }),
  );

  if (ok) {
    router.replace('/newsletter/library');
  }
};

const charts = computed(() => {
  type P = 'scheduled'|'sent'|'processing'|'abandoned'|'failure'|'all';
  const ps = (t: P) => props.campaign.publishStats![t] ?? 0;
  type D = 'processed'|'dropped'|'delivered'| 'deferred'| 'bounce'| 'blocked';
  const ds = (t: D) => props.campaign.deliveryStats![t] ?? 0;
  type E = 'open'|'unique_open'|'click'|'unique_click'|'spam'|'unsubscribe'|'group_unsubscribe'|'group_resubscribe';
  const es = (t: E) => props.campaign.engagementStats![t] ?? 0;
  type W = 'widget_open'|'unique_widget_open'|'widget_reservation'|'unique_widget_reservation'|'widget_unsubscribe';
  const ws = (t: W) => props.campaign.engagementStats![t] ?? 0;
  type C = 'all'|'imminent'|'unique_all'|'unique_imminent'|'guests_all'|'guests_imminent';
  const cs = (t: C) => props.campaign.conversionStats![t] ?? 0;

  // eslint-disable-next-line vue/max-len
  const fvalues = [ps('all'), ps('sent'), ds('delivered'), es('unique_open'), es('unique_click')];
  for (let i = fvalues.length - 2; i >= 0; i -= 1) if (fvalues[i] < fvalues[i + 1]) fvalues[i] = fvalues[i + 1];
  const [all, sent, delivered, uniqueOpen, uniqueClick] = fvalues;
  const uniqueReservations = cs('unique_imminent');
  const unsubscribe = es('unsubscribe') + ws('widget_unsubscribe');
  const reservations = cs('imminent');
  const guests = cs('guests_imminent');

  const fv = (now: number, then: number) => [now, then > 0 ? (now / then) * 100 : 0];
  const funnel = [
    { value: fv(sent, all), name: i18n.t('label.newsletters_sent') },
    { value: fv(delivered, sent), name: i18n.t('label.newsletters_delivered') },
  ];

  if (delivered > 0) {
    funnel.push({ value: fv(uniqueOpen, delivered), name: i18n.t('label.newsletters_opened') });
  }
  if (uniqueOpen > 0) {
    funnel.push({ value: fv(uniqueClick, uniqueOpen), name: i18n.t('label.newsletters_clicked') });
  }
  if (uniqueClick > 0) {
    funnel.push({ value: fv(reservations, uniqueClick), name: i18n.t('label.reservations') });
  }

  const gauge = delivered > 0 ? (unsubscribe / delivered) : 0;

  const rv = (nom: number, den: number) => (den > 0 ? `${Math.floor((nom / den) * 1000) / 10}%` : '0%');
  const stats = {
    or: rv(uniqueOpen, delivered),
    ctr: rv(uniqueClick, delivered),
    ctor: rv(uniqueClick, uniqueOpen),
    cr: rv(uniqueReservations, delivered),
    tr: `${reservations}`,
    tg: `${guests}`,
  };

  return { funnel, gauge, stats };
});

onMounted(() => {
  console.log('campaign', props.campaign);
});


return { __sfc: true,emit, props, saveAsTemplate, charts, HtmlImage, NewModalDialog, MarketingCampaignStatus, EmailPreviewFrame, NewsletterFunnelChart, NewsletterGaugeChart, colorForCampaignStatus }
}

})